import { render, staticRenderFns } from "./successPayment.vue?vue&type=template&id=0d87680a&scoped=true"
import script from "./successPayment.vue?vue&type=script&lang=js"
export * from "./successPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d87680a",
  null
  
)

export default component.exports